import type { AllRouteEndpoints } from "../routeTypes";
// Don't auto-invalidate - the operation is async and Pusher will notify when complete
export const appsCatalogsCatalogIdItemsItemIdRefreshAgenticFieldCacheKeys: AllRouteEndpoints[] = [];
